import React from "react";
import CountUp from "react-countup";

const CounterCart = ({ number, title }) => {
  return (
    <div>
      <div className="w-full h-full   md:h-[200px] pt-10 md:pt-0 pb-10 md:pb-0 flex flex-wrap items-center justify-around">
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
          <CountUp
            className="font-bold text-4xl text-white"
            duration={3}
            end={number}
          />
          <h1 className="font-bold text-4xl text-white">+</h1>
          </div>
          <p className="text-yellow mt-5 font-bold text-xl">{title}</p>
        </div>
      </div>
    </div>
  );
};

export default CounterCart;
